'use client'

import type { CompanySwitcherItemProps } from '@maestro/commerce-blocks/components/company-switcher/company-switcher.types'

import { useTranslations } from 'next-intl'

import { SwitcherItem } from '@maestro/commerce-blocks/components/switcher'

export default function CompanySwitcherItem(props: CompanySwitcherItemProps) {
  const { company, isSelected, isPending, isDisabled, onSelect } = props
  const t = useTranslations('commerce-blocks')

  const description = [
    t('company-switcher.id-label', { id: company.id }),
    company.country,
  ]
    .filter(Boolean)
    .join('\n')

  return (
    <SwitcherItem
      name={company.name}
      description={description}
      isSelected={isSelected}
      isPending={isPending}
      isDisabled={isDisabled}
      onSelect={onSelect}
    />
  )
}
